<template>
    <el-select 
        v-model="valueFormatter"
        :multiple="multiple"
        :disabled="disabled"
        filterable
        clearable
        style="width: 100%"
        :placeholder="placeholder"
        @change="handleChangeTree"
    >
        <el-option
        v-for="item in _options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
        </el-option>
    </el-select>
</template>
<script>
export default {
    name: "SelectV2",
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: "请选择",
        },
        value: {
            type: [Array, Object],
            default: () => [],
        },
        options: {
            type: Array,
            default: () => [],
        },
        size: {
            type: String,
            default: "—",
        },
    },
    data() {
        return {
            cacheValue: [],
            valueFormatter: [],
        }
    },
    watch: {
        value: {
            handler(v) {
                // value如果没有key/title，给他加上
                if (v.length) {
                    const list = JSON.parse(JSON.stringify(v));
                    this.valueFormatter = list.map((item) => {
                        return item.value ;
                    });
                } else {
                    this.valueFormatter = [];
                }
                // 单选的时候valueFormatter转化为string
                if(v.length === 1 && this.multiple === false) {
                    this.valueFormatter = this.valueFormatter.join()
                }
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        _options: (_this = this) =>
        _this.options.map((item) => {
            return { ...item, title: item.label, key: item.value };
        }),
    },
    methods: {
        handleChangeTree(value) {
            if(this.multiple && Array.isArray(value)) {
                this.cacheValue = value.map(v => {
                    return this._options.find(item => item.value == v)
                })
            }else {
                this.cacheValue = this._options.filter(item => item.value == value)
            }
            this.$emit("input", this.cacheValue)
            this.$emit("change", this.cacheValue)
        }
    }
}
</script>